import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ContactPreferencesToggleListContentContainer,
    ContactPreferencesToggleListContentHeader,
    ContactPreferencesToggleListContentRow,
    ContactPreferencesToggleListContentRowContainer,
    ContactPreferencesToggleListContentRowsContainer,
    ContactPreferencesToggleListContentRowText,
    ContactPreferencesToggleListHeader,
    ContactPreferencesToggleListSubHeader,
} from './ContactPreferencesToggleList.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Toggle } from 'src/components/toggle/Toggle';
import { ContactPreferencesNewOptionType } from 'src_server/trpc/types/accountModel/changeAccountContactPreferencesNew';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { ContactPreferencesToggleListState } from './ContactPreferencesToggleList.state';
interface ContactPreferenceType {
    type: 'email' | 'sms' | 'phone';
    text: string;
}

const ContactPreferences: ContactPreferenceType[] = [
    {
        type: 'email',
        text: 'Email',
    },
    {
        type: 'sms',
        text: 'Text Message (SMS)',
    },
    {
        type: 'phone',
        text: 'Phone Call',
    },
];

interface PropsType {
    state: ContactPreferencesToggleListState;
    contactPreferencesCategories: ContactPreferencesNewOptionType[];
    variant?: 'light' | 'dark';
    haveHeader?: boolean;
    additionalContainer?: boolean;
    onToggle?: () => Promise<void>;
}

export const ContactPreferencesToggleList = observer(
    'ContactPreferencesToggleList',
    ({
        state,
        contactPreferencesCategories,
        variant = 'dark',
        haveHeader = true,
        additionalContainer = false,
        onToggle,
    }: PropsType) => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        const configContactPreferences = configState.contactPreferences;

        return (
            <section>
                {haveHeader ? (
                    <>
                        <ContactPreferencesToggleListHeader data-test='offers-settings-new-header'>
                            <I18n
                                langKey='offers-settings.header'
                                defaultText='Choose how you receive offers'
                            />
                        </ContactPreferencesToggleListHeader>
                        <ContactPreferencesToggleListSubHeader data-test='offers-settings-sub-new-header'>
                            <I18n
                                langKey='offers-settings.subheader'
                                defaultText='Stay up to date and receive handpicked promotions, news and insider tips from us.'
                            />
                        </ContactPreferencesToggleListSubHeader>
                    </>
                ) : null}

                <ContactPreferencesToggleListContentContainer>
                    {ContactPreferences.filter((contact) => configContactPreferences.includes(contact.type)).map(
                        (contact) => (
                            <ContactPreferencesToggleListContentRowContainer
                                key={contact.type}
                                data-test='offers-settings-content-row-container'
                            >
                                <ContactPreferencesToggleListContentHeader>
                                    <I18n
                                        langKey='offers-settings.contact.type'
                                        defaultText='{text}'
                                        params={{
                                            text: contact.text,
                                        }}
                                    />
                                </ContactPreferencesToggleListContentHeader>
                                <ContactPreferencesToggleListContentRowsContainer
                                    additionalContainer={additionalContainer}
                                    systemPagesVariant={configState.componentVariants.systemPagesVariant}
                                >
                                    {contactPreferencesCategories.map((option) => (
                                        <ContactPreferencesToggleListContentRow key={option}>
                                            <ContactPreferencesToggleListContentRowText>
                                                <I18n
                                                    langKey='offers-settings.contact.type.option'
                                                    defaultText='{text}'
                                                    params={{
                                                        text: option,
                                                    }}
                                                />
                                            </ContactPreferencesToggleListContentRowText>
                                            <Toggle
                                                toggleActive={async (): Promise<void> => {
                                                    state[contact.type][option].setValue(
                                                        !state[contact.type][option].value
                                                    );
                                                    if (onToggle) {
                                                        await onToggle();
                                                    }
                                                }}
                                                variant={variant}
                                                isActive={state[contact.type][option].value}
                                            />
                                        </ContactPreferencesToggleListContentRow>
                                    ))}
                                </ContactPreferencesToggleListContentRowsContainer>
                            </ContactPreferencesToggleListContentRowContainer>
                        )
                    )}
                </ContactPreferencesToggleListContentContainer>
            </section>
        );
    }
);
